import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=b66ae246&scoped=true&"
import script from "./MobileLayout.vue?vue&type=script&lang=js&"
export * from "./MobileLayout.vue?vue&type=script&lang=js&"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=b66ae246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ae246",
  null
  
)

export default component.exports